$(document)

  .on('click', '.more-articles', function(event) {
    event.preventDefault()
    let id = `#${$(this).data('year')}`
    $(id).find('.hidden-newsletter').slideDown()
    $(this).hide()
  })

